package fr.frux.feature.harvestdetail

import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

/**
 * Formatte un timestamp (millis) en date/heure lisible, fuseau local de l'appareil.
 * Pas de nom de mois écrit en toutes lettres : éviter une table de traduction pour un seul écran.
 */
@OptIn(ExperimentalTime::class)
fun formatHarvestDateTime(epochMillis: Long): String {
    val dt = Instant.fromEpochMilliseconds(epochMillis).toLocalDateTime(TimeZone.currentSystemDefault())
    val day = dt.day.toString().padStart(2, '0')
    val month = dt.monthNumber.toString().padStart(2, '0')
    val hour = dt.hour.toString().padStart(2, '0')
    val minute = dt.minute.toString().padStart(2, '0')
    return "$day/$month/${dt.year} à $hour:$minute"
}
